define('app/sdc/target/sdc-target',[], function () {
	return {
		restrict: "A",
		template: null,
		controller: {
			bind: {
				"target": "=sdcTarget"
			},
			constructor: ["$self", "$element", "$scope", function (vm, $element, $scope) {
				vm.target = {
					element: $element,
					scope: $scope
				};
			}]
		}
	};
});
